const voice = {
  title: "音声ジェネレーター",
  description: "Tenak AI がテキストから音声を生成します。",
  content: "テキスト",
  advanceVoiceMode: "Powerd by GPT-4o mini TTS",
  instructions: "追加指示",
  instructionsPlaceholder: "明るい感じで読んでください。",
  submit: "音声を生成",
  speed: "速度",
  pitch: "ピッチ",
  language: "言語",
  voice: "声",
  library: "ライブラリ",
  typeDescription: "音声の種類について",
  googleVoiceLabel: {
    neural: "ニューラル",
    wavenet: "ナチュラル",
    studio: "スタジオ(プレビュー)",
    standard: "スタンダード",
    chirp3hd: "Chirp3−HD",
    journey: "旅の声（実験的）",
    news: "ニュース",
    polyglot: "多言語",
  },
  openaiVoiceLabel: {
    Alloy: "Alloy",
    Ash: "Ash",
    Coral: "Coral",
    Echo: "Echo",
    Fable: "Fable",
    Onyx: "Onyx",
    Nova: "Nova",
    Sage: "Sage",
    Shimmer: "Shimmer",
    Ash_A: "Ash",
    Ballad_A: "Ballad",
    Coral_A: "Coral",
    Sage_A: "Sage",
    Verse_A: "Verse",
  },
  voiceDescription: {
    neural:
      "最も自然で人間のような音声品質を提供します。このタイプはディープラーニング技術に基づいており、非常に高いリアリズムを実現しています。（Neural2）",
    wavenet:
      "高品質で自然な音声を提供します。GoogleのWaveNet技術を使用しており、リアルな音声合成が可能です。（Wavenet）",
    studio:
      "プロフェッショナルなスタジオ品質の音声を提供します。特定のアプリケーションやシナリオ向けに設計されています。",
    standard: "従来の音声生成技術を使用しています。一般的な用途に適しており、基本的な音声合成ニーズに対応します。",
    journey:
      "特定のストーリーやナラティブ向けにデザインされた実験的な音声です。特定の状況やテーマに合わせたユニークな音声体験を提供します。",
    chirp3hd:
      "Google の最新ハイエンドモデルである Chirp3−HD を使用しています。音声の品質は非常に高く、自然な音声を生成します。",
  },
  gender: {
    male: "男性",
    female: "女性",
  },
  provider: {
    title: "AI Model",
    google: "Google",
    openai: "OPEN AI",
    minimax: "MINIMAX",
  },
  minimaxDescription: "Powerd by Minimax Speech 2 HD",
  minimaxVoiceLabel: {
    Wise_Woman: "知的な女性",
    Friendly_Person: "親しみやすい人",
    Inspirational_girl: "元気な少女",
    Deep_Voice_Man: "低い声の男性",
    Calm_Woman: "落ち着いた女性",
    Casual_Guy: "カジュアルな男性",
    Lively_Girl: "活発な少女",
    Patient_Man: "忍耐強い男性",
    Young_Knight: "若い騎士",
    Determined_Man: "決断力のある男性",
    Lovely_Girl: "愛らしい少女",
    Decent_Boy: "礼儀正しい少年",
    Imposing_Manner: "威厳のある態度",
    Elegant_Man: "エレガントな男性",
    Abbess: "女性の修道院長",
    Sweet_Girl_2: "可愛らしい少女",
    Exuberant_Girl: "活気のある少女",
  },
  emotion: {
    default: "デフォルト",
    happy: "嬉しい",
    sad: "悲しい",
    angry: "怒り",
    fearful: "恐怖",
    disgusted: "嫌悪",
    surprised: "驚き",
    neutral: "普通",
  },
  message: {
    success: "音声を生成しました。音声はライブラリに保存されています。",
    error: "音声の生成に失敗しました。後ほど再度試してください。",
  },
  noPlayingVoice: "再生中の音声はありません",
};
export default voice;
